import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useApplyButtonStatus = ({
    allFiltersWithStatus,
    displayFilters,
    checkOrderCondition,
    setApplyButton,
    appliedAccountIds,
}) => {
    useEffectWithErrorLogging(() => {
        let selectedFilters = [];
        allFiltersWithStatus.accountFilter.forEach((item) => {
            if (item.isChecked && item.name !== 'All') {
                selectedFilters.push(item.name);
            }
        });
        allFiltersWithStatus.orderStatusFilter.forEach((item) => {
            if (item.isChecked && item.description !== 'All') {
                selectedFilters.push(item.description);
            }
        });
        allFiltersWithStatus.orderTypesFilter.forEach((item) => {
            if (item.isChecked && item.orderTypeName !== 'All') {
                selectedFilters.push(item.orderTypeName);
            }
        });
        allFiltersWithStatus.physicianFilter.forEach((item) => {
            if (item.isChecked && item.name !== 'All') {
                selectedFilters.push(item.name);
            }
        });
        allFiltersWithStatus.procedureFilter.forEach((item) => {
            if (item.isChecked && item.description !== 'All') {
                selectedFilters.push(item.description);
            }
        });
        if (displayFilters.length != selectedFilters.length) {
            setApplyButton(false);
        }

        // Account names can repeat across different accounts, so also compare by the unique
        // accountId when it's supplied, instead of relying on the name-based check above alone.
        let hasAccountIdChanged = false;
        if (Array.isArray(appliedAccountIds)) {
            const selectedAccountIds = allFiltersWithStatus.accountFilter
                .filter((item) => item.isChecked && item.name !== 'All')
                .map((item) => item.accountId);
            hasAccountIdChanged =
                selectedAccountIds.length !== appliedAccountIds.length ||
                selectedAccountIds.some((id) => !appliedAccountIds.includes(id));
        }

        if (
            [...displayFilters].sort().join('').toLowerCase() ===
                [...selectedFilters].sort().join('').toLowerCase() &&
            !checkOrderCondition &&
            !hasAccountIdChanged
        ) {
            setApplyButton(false);
        } else {
            setApplyButton(true);
        }
    }, [allFiltersWithStatus, appliedAccountIds]);
};

export default useApplyButtonStatus;
